// YourMainComponent.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AfterActionComponent = ({ content }) => {
  const navi = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navi('/');
    }, 3000);
    return () => clearTimeout(timer);
  }, [navi]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="flex items-center space-x-4 p-6 bg-green-500 text-white rounded-lg shadow-lg animate-bounce-in">
        <div className="flex items-center justify-center w-16 h-16 bg-white rounded-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="h-12 w-12 text-green-500"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <div>
          <h1 className="text-2xl font-bold">{content}</h1>
          <p className="text-sm">Redirecting you in a moment...</p>
        </div>
      </div>
      <h5 className="text-4xl mt-6 font-black text-gray-700">Success!</h5>
    </div>
  );
};

export default AfterActionComponent;
